import css from './DataTable.css'
import { jsFadeIn, jsFadeOut } from '../../lib/jsfunc.js'
import { on, ready, query } from '../../lib/dom.js'

ready(function () {
  var rangetable = query('.DataTable.datatable-rangetable');

  if(rangetable){
    query(rangetable, '.menuitem-rangetable > div').style.display = 'block';
    setTimeout(function() { query(rangetable, '.menuitem-rangetable > div').style.display = ''; }, 5000);
    var infolayer = query('.InfoLayer.infolayer-rangetable');
    jsFadeIn(infolayer, 0.9);
    setTimeout(function() { jsFadeOut(infolayer); }, 10000);
  }
})